import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import classNames from "classnames";
import React from "react";
import { ArrowIcon } from "../icons/ArrowIcon";

export const AccordionLink: React.FC<{ title: string; link?: string }> = ({
  title,
  link,
}) => {
  const arrow = (
    <ArrowIcon
      className={classNames(link ? "text-cotton" : "bg-yellow", "ml-40px")}
    />
  );
  return (
    <div
      data-component="Accordion Link"
      className="flex items-center justify-end py-30px"
    >
      <h3 className="h4 text-cotton">{title}</h3>
      {link ? <Link to={link}>{arrow}</Link> : <div className="">{arrow}</div>}
    </div>
  );
};
